import _ from "lodash";

const { EXIT_CURRENT_DASHBOARD } = require("redux/actions");
const { RECEIVE_VIDEO_LOOKUP_DATA } = require("redux/actions/videoFromTimestampActions");

export const videoFromTimestampReducer = (state = {}, action) => {
    if (action.type === RECEIVE_VIDEO_LOOKUP_DATA) {
        const newState = _.clone(state);
        state = {
            ...newState,
            ...action.videoLookupData,
        };
    } else if (action.type === EXIT_CURRENT_DASHBOARD) {
        state = {};
    }

    return state;
};
